'use strict';

/**
 * Dependencies
 * @ignore
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var base64url = require('base64url');
var crypto = require('@trust/webcrypto');
var TextEncoder = require('../text-encoder');

/**
 * ECDSA
 */

var ECDSA = function () {

  /**
   * constructor
   *
   * @param {string} bitlength
   */
  function ECDSA(params) {
    _classCallCheck(this, ECDSA);

    this.params = params;
  }

  /**
   * sign
   *
   * @description
   * Generate a digital signature for a given input and private key.
   *
   * @param {CryptoKey} key
   * @param {(BufferSource|String)} data
   *
   * @returns {Promise}
   */


  _createClass(ECDSA, [{
    key: 'sign',
    value: function sign(key, data) {
      var algorithm = this.params;

      // Normalize data input
      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      }

      return crypto.subtle.sign(algorithm, key, data).then(function (signature) {
        return base64url(Buffer.from(signature));
      });
    }

    /**
     * verify
     *
     * @description
     * Verify a digital signature for a given input and private key.
     *
     * @param {CryptoKey} key
     * @param {(BufferSource|String)} signature - Base64URL encoded signature.
     * @param {(BufferSource|String)} data
     *
     * @returns {Promise}
     */

  }, {
    key: 'verify',
    value: function verify(key, signature, data) {
      var algorithm = this.params;

      // Normalize signature
      if (typeof signature === 'string') {
        signature = Uint8Array.from(base64url.toBuffer(signature));
      }

      // Normalize data to be verified
      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      }

      return crypto.subtle.verify(algorithm, key, signature, data);
    }

    /**
     * Generate Key
     *
     * @description
     * Generate key pair for ECDSA.
     *
     * @param {boolean} extractable
     * @param {Array} key_ops
     * @param {Object} options
     *
     * @return {Promise}
     */

  }, {
    key: 'generateKey',
    value: function generateKey(extractable, key_ops) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var params = this.params;
      return crypto.subtle.generateKey(params, extractable, key_ops);
    }

    /**
     * importKey
     *
     * @param {JWK} key
     * @returns {Promise}
     */

  }, {
    key: 'importKey',
    value: function importKey(key) {
      var jwk = Object.assign({}, key);
      var algorithm = this.params;
      var usages = key['key_ops'] || [];
      // duplicate key operation values MUST NOT be present
      if (!(usages.length === new Set(usages).size)) {
        return Promise.reject(new Error('Invalid key operations key parameter'));
      }
      // handle use parameter for public keys
      if (key.use === 'sig') {
        usages.push('verify');
      }
      if (key.use === 'enc') {
        return Promise.reject(new Error('Invalid use key parameter'));
      }

      // Elliptic Curve is used
      // if d parameter is present, this is a private key
      if (jwk.d) {
        if (!usages.includes('sign')) {
          usages.push('sign');
        }
      } else if (!usages.includes('verify')) {
        usages.push('verify');
      }

      return crypto.subtle.importKey('jwk', jwk, algorithm, true, usages).then(function (cryptoKey) {
        Object.defineProperty(jwk, 'cryptoKey', {
          enumerable: false,
          value: cryptoKey
        });

        return jwk;
      });
    }
  }]);

  return ECDSA;
}();

/**
 * Export
 */


module.exports = ECDSA;


// WEBPACK FOOTER //
// ./lib/algorithms/ECDSA.js